// extracted by mini-css-extract-plugin
module.exports = {"container":"viewQuiz_container__3CUUS","general":"viewQuiz_general__3jnPW"};